export interface ExtJsFilter<ColKey extends string> {
  // We need an enum that has property (Ex: executedOn) but also property[min]/property[max] (Ex: executedOn[max])
  // because those are needed by the time range filter that has this kind of format in ext
  property: any;
  value: any;
}

export type FilterInstance<ColKeys extends string> = {
  [column in ColKeys]?: any; // This should have only one entry but that can't be checked because typescript is dumb
};

export interface FilterKind {
  // unfortunately, it is pretty hard to make FilterKind generic, so we use ExtJsFilter<any>
  filterInFrontend: <ColKeys extends string, Row extends Record<string, any>>(
    filter: FilterInstance<ColKeys>,
    row: Row
  ) => boolean;
}

export interface FilterValue {
  label: string;
  value: number | string;
}

export interface BaseFilterConfig {
  key: string;
  type: number;
  values?: Array<FilterValue>;
  filterResetValue?: any;
}

export enum ExactMatchCustomValues {
  MY_COMPANY = 'myCompany',
}
